import GradientToWhite from "./GradientToWhite"
import WhiteToGradient from "./WhiteToGradient"

const Waves = {
  GradientToWhite,
  WhiteToGradient,
}

export default Waves
